// extracted by mini-css-extract-plugin
export default {"beneficios":"Beneficios_beneficios__5sF0Y","list":"Beneficios_list__6f+la"};